import { updateWaiverTemplate } from "../../api/historyService";

export const useUpdateWaiverTemplate = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateWaiverTemplate(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update waiver template:", error);
        throw error;
    }
  };

  return { update };
};